module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Shuffle-2d01194f3bad0d79978e4f98c07f529f.svg";